export enum FileClaimSteps {
  SELECT_PLAN = "Select your Plan",
  ADD_CLAIM_ITEMS = "Select damaged items under your plan",
  ADD_CLAIM_ITEMS_DETAILS = "Confirm/Update Item Details", //'Confirm item details',
  ADD_CLAIM_ITEMS_DAMAGE_DETAILS = "Report your damage",
  UPDTAE_CONTACT_DETAILES = "Update your contact information",
  VERIFY_CONTACT_DETAILES = "Verify your contact information",
  REVIEW_CLAIM_DETAILS = "Review claim details",
}

export const claimStepsData = [
  {
    step_num: 1,
    title: FileClaimSteps.SELECT_PLAN,
  },
  {
    step_num: 2,
    title: FileClaimSteps.ADD_CLAIM_ITEMS,
  },
  {
    step_num: 3,
    title: FileClaimSteps.ADD_CLAIM_ITEMS_DETAILS,
  },
  {
    step_num: 4,
    title: FileClaimSteps.ADD_CLAIM_ITEMS_DAMAGE_DETAILS,
  },
  // {
  //   step_num: 5,
  //   title: FileClaimSteps.UPDTAE_CONTACT_DETAILES,
  // },
  // {
  //   step_num: 6,
  //   title: FileClaimSteps.VERIFY_CONTACT_DETAILES,
  // },
  {
    step_num: 5,
    title: FileClaimSteps.REVIEW_CLAIM_DETAILS,
  },
];
